








































import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'UserVerifyResult',
})
export default class UserVerifyResult extends Vue {
  async created() {
    window.scrollTo(100, 0);
  }

  close_window() {
    window.close();
  }
}
